export function verificationUserExternal(message){
    if(!message) return false;
    if('user_system' in message) return false;
    return true;
}